<template>
  <AppResourceLoading v-if="!auth.authInitialized" />
  <ToastProvider>
    <div v-if="auth.authInitialized" class="min-h-screen bg-background">
      <RequestProgressBar />
      <router-view />
      <ConfirmProvider />
      <GlobalLoadingOverlay />
    </div>
  </ToastProvider>
</template>

<script setup lang="ts">
import ConfirmProvider from '@/shared/components/ConfirmProvider.vue';
import AppResourceLoading from '@/shared/components/AppResourceLoading.vue';
import GlobalLoadingOverlay from '@/shared/components/GlobalLoadingOverlay.vue';
import RequestProgressBar from '@/shared/components/RequestProgressBar.vue';
import ToastProvider from '@/shared/components/ToastProvider.vue';
import { useAuthStore } from '@/features/auth/stores/auth';

const auth = useAuthStore();
</script>
